import { render } from "./SuperAdmin.vue?vue&type=template&id=b29998d8&scoped=true&ts=true"
import script from "./SuperAdmin.vue?vue&type=script&lang=ts"
export * from "./SuperAdmin.vue?vue&type=script&lang=ts"

import "./SuperAdmin.vue?vue&type=style&index=0&id=b29998d8&scoped=true&lang=css"
import "./SuperAdmin.vue?vue&type=style&index=1&id=b29998d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b29998d8"]])

export default __exports__